import { render, staticRenderFns } from "./dispatchEngineer.vue?vue&type=template&id=16cc01d7&scoped=true"
import script from "./dispatchEngineer.vue?vue&type=script&lang=js"
export * from "./dispatchEngineer.vue?vue&type=script&lang=js"
import style0 from "./dispatchEngineer.vue?vue&type=style&index=0&id=16cc01d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc01d7",
  null
  
)

export default component.exports